export enum EDialogWidth {
  large = '1200px',
  medium = '700px',
  small = '600px',
  xSmall = '500px',
  xxSmall = '320px',
}
